import { useEffect } from "react";
import { runRootServiceWorker } from "../runRootServiceWorker";
import { userSelector, notAuthenticatedUserId } from "@/features/Auth/CurrentUser/Slice/CurrentUserSlice";
import { useSelector } from "react-redux";

function RunRootServiceWorker() {

    const user = useSelector(userSelector);
    const userLoggedIn = user.id !== notAuthenticatedUserId;

    useEffect(() => {
        if (userLoggedIn) {
            runRootServiceWorker();
        }
    }, [userLoggedIn]);

    return (
        <></>
    );
}

export default RunRootServiceWorker;